import React, { useState, useEffect } from "react";
import Loader from "./Loader";
import Congratulations from "./Congratulations";
import {
  getOrderDetails,
  getdeliverytime,
  getGeofenceByFleetId,
  getFleetConfigByFleetId,
} from "../API";
import { findNorthWestAndSouthEast } from "../utils";

import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
function OrderStatus() {
  const [isLoading, setIsLoading] = useState(true);
  const [orderDetails, setorderDetails] = useState(null);
  const [etaDetails, setETADetails] = useState(null);
  const [etaLoader, setETALoader] = useState(true);
  const { orderID } = useParams();
  const [otp, setOtp] = useState(orderID?.substr(-4));
  const history = useNavigate();
  const [maxBoundCordinates, setBoundCordinates] = useState({});
  const fetchBoundCordinates = () => {
    getGeofenceByFleetId(process.env.REACT_APP_FLEETID).then((res) => {
      setBoundCordinates(findNorthWestAndSouthEast(res.data.geofence));
    });
  }
  const fetchOrderDetails =  () => {
    getOrderDetails(orderID)
      .then((res) => {
        localStorage.setItem("name", res?.data?.data?.name);
        localStorage.setItem("email", res?.data?.data?.email);
        localStorage.setItem("phone", res?.data?.data?.phone);
        sessionStorage.setItem("pin", res?.data?.data?.pin);
        if (!!Number(process.env.REACT_APP_ONLYPICKUP)) {
          if (res?.data?.data?.statusCode > 5) {
            if ([10, 14,15,22].includes(res.data?.data.statusCode)) {
              history(`/ordercancel/${orderID}`);
            } else {
              history(`/orderpickedup/${orderID}`);
            }
          }
        } else {
          if (res.data?.data?.statusCode === 9) {
            history(`/orderdelivered/${orderID}`);
          }
          if ([10, 14, 19, 20, 21, 22].includes(res.data?.data.statusCode)) {
            history(`/ordercancel/${orderID}`);
          }
        }
        setorderDetails(res?.data?.data);

        setOtp(orderID.substr(-4));
        // setIsLoading(false);
      })
      .catch((err) => {
        // setIsLoading(false);
        console.log("Error ", err);
      });
  }

  useEffect(() => {
    setIsLoading(true);
    fetchOrderDetails();
    fetchBoundCordinates();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(
      fetchOrderDetails
     , 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);
  useEffect(() => {
    const intervalId = setInterval(() => {
      getdeliverytime(orderID)
        .then((res) => {
          setETADetails(res?.data?.result);
          setETALoader(false);
        })
        .catch((err) => {
          setETALoader(true);
          console.log("Error ", err);
        });
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);
  useEffect(() => {
    const fetchFleetConfig = async () => {
      try {
        const response = await getFleetConfigByFleetId(process.env.REACT_APP_FLEETID);
        const data = response?.data?.data;
        localStorage.setItem("fleetConfig", JSON.stringify(data));
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchFleetConfig();
  }, []);
  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
      <Congratulations
        maxBoundCordinates={maxBoundCordinates}
        orderDetails={orderDetails}
        otp={otp}
        eta={etaDetails}
        etaLoader={etaLoader}
        isLoading={isLoading}
      />
        )}
    </div>
  );
}

export default OrderStatus;
